import React from 'react';
import { choose } from '../../utils/platform';
import { useOtp } from './useOtp';
import OTPDesktop from './OTP.desktop';
import OTPMobile from './OTP.mobile';

const OTPView = choose(OTPDesktop, OTPMobile);

export default function OTP() {
  const vm = useOtp();
  return <OTPView vm={vm} />;
}
